import { emailValidation } from '@/scripts/constants/regex';

const validateEmail = email => {
  const result = emailValidation.test(String(email).toLowerCase());

  return result;
};

/*  */
export { validateEmail };
